import React, { createContext, useState, useCallback } from "react";
import { API_BASE_URL } from "../config/api";

export const ProductsContext = createContext();



export const ProductsProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ================= FETCH PRODUCTS =================
const fetchProducts = useCallback(async () => {
  setLoading(true);
  setError(null);

  try {
    const token = localStorage.getItem("authToken");

    const response = await fetch(`${API_BASE_URL}/api/products`, {
      headers: token
        ? { Authorization: `Bearer ${token}` }
        : {},
    });

    if (!response.ok) {
      throw new Error("Failed to fetch products");
    }

    const data = await response.json();

    const normalizedData = Array.isArray(data)
      ? data.map((p) => ({
          ...p,
          is_published: Number(p.is_published),
        }))
      : [];

    setProducts(normalizedData);
  } catch (err) {
    setError(err.message || "Unknown error");
  } finally {
    setLoading(false);
  }
}, []);

  // ================= CREATE PRODUCT =================
  const createProduct = async (formData) => {
    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        throw new Error("Not authenticated");
      }

      const response = await fetch(`${API_BASE_URL}/api/products`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to create product");
      }

      const newProduct = await response.json();

      setProducts((prev) => [newProduct, ...prev]);

      return newProduct;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  // ================= DELETE PRODUCT =================
  const deleteProduct = async (id) => {
    // optimistic UI update
    const previousProducts = products;

    setProducts((prev) =>
      prev.filter((p) => String(p.id) !== String(id))
    );

    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        throw new Error("Not authenticated");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/products/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Delete failed");
      }
    } catch (err) {
      console.error(err);

      // rollback if fail
      setProducts(previousProducts);
      fetchProducts();
    }
  };

  return (
    <ProductsContext.Provider
      value={{
        products,
        loading,
        error,
        fetchProducts,
        createProduct,
        deleteProduct,
        setProducts,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};